@if (loading) {
  <div class="text-center" style="width: 300px; position: absolute; height: 50vh; top: 45%">
    <mat-spinner diameter="24" style="display: inline-block"></mat-spinner>
  </div>
}

<div class="ag-pa-md">
  @if (!loading && tracking && page1) {
    <div class="email-list">
      <h4>Guest Tracking</h4>
      <br />
      <h6>{{ tracking?.loginInstructions }}</h6>
      <br />
      <form (ngSubmit)="submitForm(guestForm)" [formGroup]="guestForm">
        <div class="form-group">
          <label for="Username"> {{ tracking?.usernameLabel }}</label>
          <input
            type="text"
            class="form-control"
            id="username"
            title="User Name"
            formControlName="Username"
            aria-describedby="usernameHelp"
            placeholder="Enter Username"
          />
        </div>
        <div class="form-group">
          <label for="Username"> {{ tracking?.passwordLabel }}</label>
          <input
            type="password"
            class="form-control"
            title="Password"
            formControlName="Password"
            aria-describedby="usernameHelp"
            placeholder="Enter Password:"
          />
        </div>
        <button
          role="button"
          aria-label="Submit"
          type="submit"
          class="btn btn-primary"
          [disabled]="!guestForm.valid"
        >
          Submit
        </button>
      </form>
    </div>
  }

  @if (!page1 && requests) {
    <div class="email-list">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <a
              style="text-decoration: underline; cursor: pointer"
              tabindex="0"
              (click)="back()"
              (keyup.enter)="back()"
            >
              <h5>Back</h5>
            </a>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            @if (this.limitMessage !== '') {
              <div>
                <b>{{ limitMessage }}</b>
              </div>
            }
          </div>
        </div>
        <!-- <hr style="border-color:var(--header-color);width:100%"> -->
        <div class="row">
          @if (items.length > 0) {
            <div class="col-12">
              <!-- <div class="per-items">
                  <div class="device-only d-block d-lg-none col-12 clearfix"> -->
              <!-- <div *ngFor="let item of requests?.items"> -->
              @for (item of items; track item) {
                <div class="quick-content">
                  <hr style="border-color: var(--header-color)" />
                  @if (item) {
                    <h5>Request Details</h5>
                  }
                  @if (item?.requestId) {
                    <div>
                      ID:
                      <b>{{ item?.requestId }}</b>
                    </div>
                  }
                  @if (item?.requestDate) {
                    <div>
                      Date:
                      <b>{{ item?.requestDate }}</b>
                    </div>
                  }
                  @if (item?.needByDate) {
                    <div>
                      Need By:
                      <b>{{ item?.needByDate }}</b>
                    </div>
                  }
                  @if (
                    $safeNavigationMigration(item?.documentURL) !== null && item?.documentURL !== ''
                  ) {
                    <div>
                      <a
                        class="a-link"
                        tabindex="0"
                        (click)="onNavigate($safeNavigationMigration(item?.documentURL))"
                        (keyup.enter)="onNavigate($safeNavigationMigration(item?.documentURL))"
                        >Electronic Attachment</a
                      >
                    </div>
                  }
                  @for (info of item?.documentInfo; track info) {
                    <div class="margin-top-5">
                      <span
                        ><strong>{{ info?.fileName }}</strong> {{ info?.message }}</span
                      >
                    </div>
                  }
                  @if (item?.showPickupLocations) {
                    <div>
                      Pick Up Location:
                      <b>{{ item?.showPickupLocations }}</b>
                    </div>
                  }
                  @if (item?.currentPickupLocation) {
                    <div>
                      Current Location:
                      <b>{{ item?.currentPickupLocation }}</b>
                    </div>
                  }
                  <br />
                  @if (item) {
                    <h5>Item Details</h5>
                  }
                  @if (item?.title) {
                    <div>
                      Title:
                      <b>{{ item.title }}</b>
                    </div>
                  }
                  @if (item?.author) {
                    <div>
                      Author:
                      <b>{{ item?.author }}</b>
                    </div>
                  }
                  @if (item?.pubYear) {
                    <div>
                      Pub Year:
                      <b>{{ item?.pubYear }}</b>
                    </div>
                  }
                  @if (item?.status) {
                    <div>
                      Status:
                      <b>{{ item?.status }}</b>
                    </div>
                  }
                  <br />
                  <!-- <div *ngIf='!item.pickupLocations === [""]'>
                            <label>Pickup Locations:</label>
                            <select #options2>
                              <option *ngFor="let options of item.pickupLocations"></option>
                            </select>
                          </div> -->
                  <!-- <hr style="border-color:var(--header-color);width:100%"> -->
                </div>
              }
              <!-- </div> -->
              <!-- </div>
                </div> -->
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
